import { all } from "redux-saga/effects";

import getLocationSaga from "./location";
import getCategorySaga from "./category";
import getResponseFileSaga from "./file";

export default function* staticSaga() {
  yield all([getLocationSaga(), getCategorySaga(), getResponseFileSaga()]);
}
